import { LocationStrategy } from '@angular/common';

export function getLocaleFromUrl(locationStrategy: LocationStrategy): string {
  return locationStrategy.getBaseHref().replaceAll('/', '');
}
